import {
    STORY_CREATE_SUCCESS,
    STORY_CREATE_FAIL,
    STORY_UPDATE_SUCCESS,
    STORY_UPDATE_FAIL,
    STORY_DELETE_SUCCESS,
    STORY_DELETE_FAIL,
    STORY_GET_SUCCESS,
    STORY_GET_FAIL,
    STORY_GET_SINGLE_SUCCESS,
    STORY_GET_SINGLE_FAIL,
    STORY_TOGGLE_PINNED_SUCCESS,
    STORY_TOGGLE_PINNED_FAIL,
    STORY_TOGGLE_MAIN_SUCCESS,
    STORY_TOGGLE_MAIN_FAIL,
    STORY_SUCCESS_MESSAGE_CLEAR,
    STORY_ERROR_CLEAR
} from "../types/storyTypes";

const initialState = {
    stories: [],
    currentStory: null,
    successMessage: {
        create: "",
        get: "",
        update: "",
        delete: "",
        togglePinned: "",
        toggleMain: ""
    },
    errorMessage: null,
};

export const StoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case STORY_GET_SUCCESS:
            return {
                ...state,
                stories: action.payload.stories,
                successMessage: {
                    ...state.successMessage,
                    get: action.payload.successMessage
                },
                errorMessage: null
            };

        case STORY_GET_FAIL:
            return {
                ...state,
                errorMessage: action.payload.error
            };

        case STORY_GET_SINGLE_SUCCESS:
            return {
                ...state,
                currentStory: action.payload.story,
                errorMessage: null
            };

        case STORY_GET_SINGLE_FAIL:
            return {
                ...state,
                errorMessage: action.payload.error
            };

        case STORY_CREATE_SUCCESS:
            return {
                ...state,
                stories: action.payload.stories,
                successMessage: {
                    ...state.successMessage,
                    create: action.payload.successMessage
                },
                errorMessage: null
            };

        case STORY_CREATE_FAIL:
            return {
                ...state,
                errorMessage: action.payload.error
            };

        case STORY_UPDATE_SUCCESS:
            return {
                ...state,
                stories: action.payload.stories,
                successMessage: {
                    ...state.successMessage,
                    update: action.payload.successMessage
                },
                errorMessage: null
            };

        case STORY_UPDATE_FAIL:
            return {
                ...state,
                errorMessage: action.payload.error
            };

        case STORY_DELETE_SUCCESS:
            return {
                ...state,
                stories: action.payload.stories,
                successMessage: {
                    ...state.successMessage,
                    delete: action.payload.successMessage
                },
                errorMessage: null
            };

        case STORY_DELETE_FAIL:
            return {
                ...state,
                errorMessage: action.payload.error
            };

        case STORY_TOGGLE_PINNED_SUCCESS:
            return {
                ...state,
                stories: action.payload.stories,
                successMessage: {
                    ...state.successMessage,
                    togglePinned: action.payload.successMessage
                },
                errorMessage: null
            };

        case STORY_TOGGLE_PINNED_FAIL:
            return {
                ...state,
                errorMessage: action.payload.error
            };

        case STORY_TOGGLE_MAIN_SUCCESS:
            return {
                ...state,
                stories: action.payload.stories,
                successMessage: {
                    ...state.successMessage,
                    toggleMain: action.payload.successMessage
                },
                errorMessage: null
            };

        case STORY_TOGGLE_MAIN_FAIL:
            return {
                ...state,
                errorMessage: action.payload.error
            };

        case STORY_SUCCESS_MESSAGE_CLEAR:
            return {
                ...state,
                successMessage: {
                    create: "",
                    get: "",
                    update: "",
                    delete: "",
                    togglePinned: "",
                    toggleMain: ""
                }
            };

        case STORY_ERROR_CLEAR:
            return {
                ...state,
                errorMessage: null
            };

        default:
            return state;
    }
};

